import React from "react";

import { Grid, Text } from "atoms";

export const AvatarIcon = ({ name, height, width, fontSize }) => {
  return (
    <Grid
      placeItems="center"
      height={height}
      width={width}
      border="2px solid"
      borderColor="secondary.700"
      borderRadius="4rem"
      bg="secondary.50"
    >
      <Text fontSize={fontSize} color="secondary.700" fontFamily="primaryExtraBold">
        {name === "null" ? "G" : name?.substring(0, 1).toUpperCase()}
      </Text>
    </Grid>
  );
};

AvatarIcon.defaultProps = {
  height: "4rem",
  width: "4rem",
  fontSize: "2rem",
};
